import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useExtractOcrDataQuery, useGetOcrFactureQuery, useLazyExtractOcrDataQuery } from 'actions/orc/queries';
import { DEFAULT_API_IMAGE } from 'routes/api/endpoints';
import ButtonGreen from 'components/buttons/ButtonGreen';
import { toast } from 'react-toastify';
import left from "../../image/arrow-left.png";

//***************************************Pour l'écriture comptable***********************************************************//
import { FormProvider, useForm } from "react-hook-form";
import { useGetCodesQuery } from "actions/comptabilite/queries";
import { useGetCodeJournalQuery } from "actions/sage_clone/code_journaux/queries";
import { useSelector } from 'react-redux';
import { getUser } from 'redux/features/userSliceWithTokenValidation';
import useJournalData from "./useJournalData";
import ModalJournal from "./ModalJournal";
//***************************************END(Pour l'écriture comptable)******************************************************//

function ViewInvoice() {
    //////////////////////////////////////////Pour les écritures comptables ///////////////////////////////////////////////////
    const { clientID: dossier_id } = useParams();
    const { updatedJournal, refetch } = useJournalData(dossier_id);
    const { data: codesResponse = [], isLoading: isLoadingResponse } = useGetCodesQuery({ dossier_client: dossier_id });
    const userStatus = useSelector(getUser);
    const {
        data: codeJournalResponse = [],
        isLoading: isLoadingcodeJournals,
    } = useGetCodeJournalQuery({ comptable: userStatus?.id });
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleDossierCreated = () => {
        setIsModalOpen(false);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    
    const openModal = () => {
        setIsModalOpen(true);
        refetch()
    };
    
    if (!isLoadingResponse) console.log("Mes codes ordered: ", codesResponse);
    if (!isLoadingcodeJournals) console.log("Mes codes journaux: ", codeJournalResponse.data);
    ////////////////////////////////////END(Pour les écritures comptables)///////////////////////////////////////////////////
    
    const location = useLocation();
    const navigate = useNavigate();
    const { ocrId, dataFromOCR, fileUrl: locationFileUrl } = location.state || {};
    const { id } = useParams();

    const [ocrResult, setOcrResult] = useState(null);
    const [fileUrl, setFileUrl] = useState(locationFileUrl || null);

    const { data: factures, isLoading: isFacturesLoading } = useGetOcrFactureQuery(dossier_id);
    
    // FIX 1: Use `id` parameter if `ocrId` is not available
    const actualOcrId = ocrId || id;
    
    const { data: ocrData, isLoading, isError, error } = useExtractOcrDataQuery(actualOcrId, {
        skip: !actualOcrId, // Only skip if both are undefined
    });
    
    console.log("Facture from OCR ", factures);
    console.log("Data from OCR query", ocrData);
    console.log("Using OCR ID:", actualOcrId);
    
    const [triggerExtractOcrData, { isLoading: isExtracting }] = useLazyExtractOcrDataQuery();

    //************************************** Nouveaux élements pour le tableau ******************************************* */    
    const [items, setItems] = useState([
        { id: 1, description: '', quantity: 0, price: 0, taxe: 0, amount: 0, amount_taxe: 0, amount_ttc: 0 }
    ]);

    const tableStyles = {
        container: {
            width: '100%',
            overflowX: 'auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif'
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '20px',
            backgroundColor: '#fff'
        },
        th: {
            backgroundColor: '#f8f9fa',
            padding: '12px',
            textAlign: 'left',
            borderBottom: '2px solid #dee2e6',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#333'
        },
        td: {
            padding: '12px',
            borderBottom: '1px solid #dee2e6',
            fontSize: '14px'
        },
        input: {
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            outline: 'none'
        },
        numberInput: {
            width: '100px',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            outline: 'none'
        },
        addButton: {
            backgroundColor: '#4CAF50',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            marginTop: '10px'
        },
        addEcriture: {
            backgroundColor: '#068f7a',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            marginTop: '10px',
            marginLeft: '20px'
        },
        deleteButton: {
            backgroundColor: '#ff4444',
            color: 'white',
            padding: '6px 12px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px'
        },
        totalRow: {
            textAlign: 'right',
            padding: '20px 0',
            fontWeight: 'bold',
            fontSize: '16px'
        }
    };

    const handleChange = (id, field, value) => {
        setItems(prevItems => prevItems.map(item => {
            if (item.id === id) {
                const updatedItem = { ...item, [field]: value };
                if (field === 'quantity' || field === 'price' || field === 'taxe') {
                    // Recalculate amounts
                    const qty = parseFloat(updatedItem.quantity) || 0;
                    const price = parseFloat(updatedItem.price) || 0;
                    const taxe = parseFloat(updatedItem.taxe) || 0;
                    
                    updatedItem.amount = (qty * price).toFixed(2);
                    updatedItem.amount_taxe = ((qty * price * taxe) / 100).toFixed(2);
                    updatedItem.amount_ttc = (qty * price * (1 + taxe / 100)).toFixed(2);
                }
                return updatedItem;
            }
            return item;
        }));
    };

    const addRow = () => {
        const newId = items.length > 0 ? Math.max(...items.map(item => item.id)) + 1 : 1;
        setItems([...items, { id: newId, description: '', quantity: 0, price: 0, taxe: 0, amount: 0, amount_taxe: 0, amount_ttc: 0 }]);
    };

    const deleteRow = (id) => {
        if (items.length > 1) {
            setItems(items.filter(item => item.id !== id));
        }
    };
    //************************************** End Nouveaux élements pour le tableau ******************************************* */    

    useEffect(() => {
        // FIX 2: Handle data from different sources
        let sourceData = null;
        
        if (dataFromOCR) {
            sourceData = dataFromOCR;
        } else if (ocrData) {
            sourceData = ocrData;
        } else if (ocrResult) {
            sourceData = ocrResult;
        }
        
        if (sourceData) {
            console.log("Processing source data:", sourceData);
            const newItems_sans_ttc = transformArraysToDictionaries(sourceData);
            const newItems = calcul_rate(newItems_sans_ttc);
            setItems(newItems);
        }
        
        if (id && factures) {
            const facture = factures?.data?.find((f) => f.id === parseInt(id));
            
            if (facture) {
                setFileUrl(facture.file);
            }
        }
    }, [id, factures, dataFromOCR, ocrData, ocrResult]);

    // Handle OCR execution
    const handleExecuteOcr = async () => {
        if (!fileUrl) {
            toast.warning('Aucune image disponible pour l\'extraction.');
            return;
        }

        try {
            const ocrResponse = await triggerExtractOcrData(id || ocrId).unwrap();
            console.log("OCR Response:", ocrResponse);
            setOcrResult(ocrResponse);
            toast.success('Extraction OCR réussie.');
            const newItems_sans_ttc = transformArraysToDictionaries(ocrResponse);
            const newItems = calcul_rate(newItems_sans_ttc);
            setItems(newItems);
            console.log("Response New Items", newItems);
        } catch (err) {
            toast.error('Erreur lors de l\'extraction OCR.');
            console.error(err);
        }
    };

    // FIX 3: Updated function to handle the correct data structure from backend
    const transformArraysToDictionaries = (data) => {
        // Handle different possible data structures
        let lineItems = [];
        
        if (data?.line_items) {
            // Backend format
            lineItems = data.line_items;
        } else if (data?.items) {
            // Alternative format
            lineItems = data.items;
        } else if (Array.isArray(data)) {
            // Direct array
            lineItems = data;
        } else {
            console.warn("Unexpected data structure:", data);
            return [{
                id: 1,
                description: '',
                quantity: 0,
                price: 0,
                taxe: 0,
                amount: 0
            }];
        }

        return lineItems.map((item, index) => {
            return {
                id: index + 1,
                description: item.description || '',
                quantity: parseFloat(item.quantity) || 0,
                price: parseFloat(
                    item.price || 
                    item.unit_price || 
                    item.total_ht || 
                    item.subtotal_ht || 
                    0
                ),
                taxe: parseFloat(
                    item.taxe || 
                    item.vat_rate || 
                    item.rate || 
                    0
                ),
                amount: parseFloat(
                    item.amount || 
                    item.total || 
                    item.total_amount ||
                    item.total_ttc || 
                    0
                ),
            };
        });
    };

    const calcul_rate = (arrays) => {
        return arrays.map((array, index) => {
            const qty = parseFloat(array.quantity) || 0;
            const price = parseFloat(array.price) || 0;
            const taxe = parseFloat(array.taxe) || 0;
            const amount = parseFloat(array.amount) || (qty * price);
            
            return {
                id: index + 1,
                description: array.description,
                quantity: qty,
                price: price,
                taxe: taxe,
                amount: amount.toFixed(2),
                amount_taxe: ((amount * taxe) / 100).toFixed(2),
                amount_ttc: (amount * (1 + taxe / 100)).toFixed(2)
            }
        })
    }

    // Process the OCR data
    const processedData = (ocrResult && processOcrData(ocrResult)) || 
                         (ocrData && processOcrData(ocrData)) || 
                         (dataFromOCR && processOcrData(dataFromOCR)) || {
        lineItems: [],
        columns: [
            {
                dataField: 'description',
                text: 'Description',
            },
            {
                dataField: 'quantity',
                text: 'Quantité',
            },
            {
                dataField: 'price',
                text: 'Prix Unitaire',
            },
            {
                dataField: 'amount',
                text: 'Prix Total',
            },
        ],
        invoiceRef: '',
        invoiceDate: '',
        totalAmount: '',
    };

    if (isFacturesLoading || isLoading) return <p>Chargement...</p>;
    if (isError) return <p>Erreur : {error?.data?.message || error.error}</p>;

    const methods = useForm();
    
    return (
        <div style={{ padding: '20px' }}>
            <div
                style={{cursor: "pointer", width: "fit-content"}}
                onClick={() => navigate(-1)}>
                <img
                    src={left}
                    className="imageLeft"
                    style={{width: "10px", height: "14px"}}
                />
                <span style={cardStyle} className="mx-2">
                    Retour
                </span>
            </div>
            <h1>Détails de la Facture</h1>
            
            {/* Display invoice info */}
            <div style={{ marginBottom: '20px' }}>
                {processedData.invoiceRef && <p><strong>Référence Facture:</strong> {processedData.invoiceRef}</p>}
                {processedData.invoiceDate && <p><strong>Date Facture:</strong> {processedData.invoiceDate}</p>}
            </div>
            
            {/* Display the image */}
            {fileUrl && (
                <div style={{ marginBottom: '20px' }}>
                    <img
                        src={id ? fileUrl : DEFAULT_API_IMAGE + fileUrl}
                        alt="Facture"
                        style={{ maxWidth: '100%', marginBottom: '20px', opacity: isExtracting ? 0.5 : 1 }}
                    />
                    {id && (
                        <ButtonGreen
                            text={isExtracting ? 'Extraction en cours...' : 'Extraire OCR'}
                            onClick={handleExecuteOcr}
                            disabled={isExtracting}
                        />
                    )}
                </div>
            )}

            {/***************************************** structure de la table ****************************************************/}      
            <div style={tableStyles.container}>
                <table style={tableStyles.table}>
                    <thead>
                        <tr>
                            <th style={tableStyles.th}>Description</th>
                            <th style={tableStyles.th}>Quantité</th>
                            <th style={tableStyles.th}>Prix Unitaire</th>
                            <th style={tableStyles.th}>Taxe(%)</th>
                            <th style={tableStyles.th}>Prix Hors Taxe</th>
                            <th style={tableStyles.th}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item => (
                            <tr key={item.id}>
                                <td style={tableStyles.td}>
                                    <input
                                        type="text"
                                        value={item.description}
                                        onChange={(e) => handleChange(item.id, 'description', e.target.value)}
                                        style={tableStyles.input}
                                        placeholder="Description"
                                    />
                                </td>
                                <td style={tableStyles.td}>
                                    <input
                                        type="number"
                                        value={item.quantity}
                                        onChange={(e) => handleChange(item.id, 'quantity', e.target.value)}
                                        style={tableStyles.numberInput}
                                        min="0"
                                    />
                                </td>
                                <td style={tableStyles.td}>
                                    <input
                                        type="number"
                                        value={item.price}
                                        onChange={(e) => handleChange(item.id, 'price', e.target.value)}
                                        style={tableStyles.numberInput}
                                        min="0"
                                        step="0.01"
                                    />
                                </td>
                                <td style={tableStyles.td}>
                                    <input
                                        type="number"
                                        value={item.taxe}
                                        onChange={(e) => handleChange(item.id, 'taxe', e.target.value)}
                                        style={tableStyles.numberInput}
                                        min="0"
                                        step="0.01"
                                    />
                                </td>
                                <td style={tableStyles.td}>
                                    <input
                                        type="number"
                                        value={item.amount}
                                        onChange={(e) => handleChange(item.id, 'amount', e.target.value)}
                                        style={tableStyles.numberInput}
                                        min="0"
                                        step="0.01"
                                    />
                                </td>
                                <td style={tableStyles.td}>
                                    <button
                                        onClick={() => deleteRow(item.id)}
                                        style={tableStyles.deleteButton}
                                        disabled={items.length === 1}
                                    >
                                        Supprimer
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div>
                    <button
                        onClick={addRow}
                        style={tableStyles.addButton}
                    >
                        Ajouter une ligne
                    </button>
                    
                    <button
                        onClick={openModal}
                        style={tableStyles.addEcriture}
                    >
                        Créer des écritures comptables
                    </button>
                </div>

                <div style={tableStyles.totalRow}>
                    Total Général: {' '}
                    {items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
                        .toLocaleString('fr-FR', {
                            style: 'currency',
                            currency: 'EUR'
                        })}
                </div>
            </div>
            {/***************************************** end of structure de la table **********************************************/}    
            
            {processedData.totalAmount && (
                <div style={{ marginTop: '20px', textAlign: 'right' }}>
                    <p><strong>Total:</strong> {processedData.totalAmount} €</p>
                </div>
            )}

            {/**********************************************************Modal Ecriture Comptable************************************************ */}
            {isModalOpen && (
                <FormProvider {...methods}>
                    <ModalJournal
                        isOpen={isModalOpen}
                        onClose={closeModal}
                        onDossierCreated={handleDossierCreated}
                        journals={updatedJournal}
                        codes={codesResponse || []}
                        codeJournalResponse={codeJournalResponse.data || []}
                        refetch={refetch}
                        dossier_id={dossier_id}
                        ecritures={items}
                    >
                        <h2 style={{ color: " #009688", fontSize: "20px", fontWeight: 700 }}>
                            <span>
                                {" "}
                                <img src={left} alt="back" />
                            </span>{" "}
                            &nbsp;CREER UN NOUVEAU DOSSIER CLIENT
                        </h2>
                    </ModalJournal>
                </FormProvider>
            )}
            {/**********************************************************END(Modal Ecriture Comptable)************************************************ */}
        </div>
    );
}

export default ViewInvoice;

const cardStyle = {
    color: "#009688",
    fontWeight: "700",
    fontSize: "15px",
    fontFamily: "Montserrat",
};

// Function to process OCR data - Updated to handle new backend structure
function processOcrData(ocrData) {
    // FIX 4: Handle the new backend response structure
    if (ocrData?.invoice_details || ocrData?.line_items) {
        // New backend format
        const lineItems = (ocrData.line_items || []).map((item, index) => ({
            id: index + 1,
            description: item.description || '',
            quantity: item.quantity || 0,
            price: item.unit_price || 0,
            amount: item.total_amount || item.amount || 0
        }));

        return {
            lineItems,
            columns: [
                { dataField: 'description', text: 'Description' },
                { dataField: 'quantity', text: 'Quantité' },
                { dataField: 'price', text: 'Prix Unitaire' },
                { dataField: 'amount', text: 'Prix Total' },
            ],
            invoiceRef: ocrData.invoice_details?.invoice_number || '',
            invoiceDate: ocrData.invoice_details?.invoice_date || '',
            totalAmount: ocrData.totals?.total_amount_due || ocrData.invoice_details?.total_amount || '',
        };
    }

    // Old format - keep for backward compatibility
    let headers = [];
    let headerRowIndex = -1;
    let foundHeader = false;
    let lineItems = [];
    let invoiceRef = '';
    let invoiceDate = '';
    let totalAmount = '';
    const totalRegex = /total\s*(t\.?t\.?c\.?)?\s*[:-]?\s*(\d+[,.]?\d*)\s*€?/i;

    if (!Array.isArray(ocrData)) {
        return { lineItems: [], columns: [], invoiceRef, invoiceDate, totalAmount };
    }

    for (let i = 0; i < ocrData.length; i++) {
        const row = ocrData[i];
        const rowText = row.join(' ').toLowerCase();

        if (rowText.includes('réf. facture')) {
            invoiceRef = row.join(' ').replace(/réf\. facture[:-]?/i, '').trim();
            continue;
        }

        if (rowText.includes('date facture')) {
            invoiceDate = row.join(' ').replace(/date facture[:-]?/i, '').trim();
            continue;
        }

        const totalMatch = rowText.match(totalRegex);
        if (totalMatch) {
            totalAmount = totalMatch[2].replace(',', '.');
            continue;
        }

        if (!foundHeader) {
            const headerTerms = ['description', 'désignation', 'quantité', 'prix unitaire', 'prix total', 'total h.t'];
            const headerFound = headerTerms.some(term => rowText.includes(term));
            if (headerFound) {
                headers = row;
                headerRowIndex = i;
                foundHeader = true;
                break;
            }
        }
    }

    if (!foundHeader) {
        return { lineItems: [], columns: [], invoiceRef, invoiceDate, totalAmount };
    }

    const columnMap = {};
    headers.forEach((header, index) => {
        const headerText = header.toLowerCase();
        if (headerText.includes('description') || headerText.includes('désignation')) {
            columnMap.description = index;
        } else if (headerText.includes('quantité')) {
            columnMap.quantity = index;
        } else if (headerText.includes('prix unitaire')) {
            columnMap.price = index;
        } else if (headerText.includes('prix total') || headerText.includes('total h.t')) {
            columnMap.amount = index;
        }
    });

    const columns = [
        { dataField: 'description', text: 'Description' },
        { dataField: 'quantity', text: 'Quantité' },
        { dataField: 'price', text: 'Prix Unitaire' },
        { dataField: 'amount', text: 'Prix Total' },
    ];

    for (let i = headerRowIndex + 1; i < ocrData.length; i++) {
        const row = ocrData[i];
        if (row.length === 0) continue;

        const lineItem = {};
        for (const [key, index] of Object.entries(columnMap)) {
            lineItem[key] = row[index] || '';
        }

        if (!lineItem.description && lineItems.length > 0) {
            lineItems[lineItems.length - 1].description += ' ' + row.join(' ');
            continue;
        }

        lineItem.id = i;
        lineItems.push(lineItem);
    }

    if (!totalAmount) {
        let total = 0;
        lineItems.forEach(item => {
            let price = parseFloat(
                item.amount?.replace(',', '.').replace(/[^0-9.]/g, '') || 0
            );
            total += price;
        });
        totalAmount = total.toFixed(2);
    }

    return { lineItems, columns, invoiceRef, invoiceDate, totalAmount };
}